import { useSplitTreatments } from '@splitsoftware/splitio-react';

/**
 * Returns whether a feature flag is enabled or not after it's been fetched from Split.
 *
 * @see https://app.split.io/org/c28b21f0-96e5-11ef-a307-0616f9fd3b13/ws/c2ae6160-96e5-11ef-a307-0616f9fd3b13/splits/dceeb0a0-1a0e-11f0-8846-92c24e662170/env/c2d941f0-96e5-11ef-a307-0616f9fd3b13/definition
 */
export function useFeatureFlag<T extends string>(
  name: T,
): Record<'isEnabled' | 'isReady', boolean> {
  const { treatments, isReady } = useSplitTreatments({ names: [name] });

  return {
    isEnabled: isReady && treatments[name]?.treatment === 'on',
    isReady,
  };
}
